import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
const API_URL = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 45000, // 45 seconds - generous for competition
});

export const searchContent = async (query, language = 'en') => {
  try {
    const response = await api.post('/search/', {
      query,
      language,
      country_code: language === 'en' ? 'us' : language,
    });
    return response.data;
  } catch (error) {
    console.error("Search API Error:", error);
    throw error;
  }
};

export const analyzeContent = async (content, language = 'en') => {
  try {
    const response = await api.post('/analysis/', {
      content,
      language,
    });
    return response.data;
  } catch (error) {
    console.error("Analysis API Error:", error);
    throw error;
  }
};

export const getHistory = async () => {
  try {
    const response = await api.get('/analysis/history');
    return response.data;
  } catch (error) {
    console.error("History API Error:", error);
    throw error;
  }
};

export const clearHistory = async () => {
  try {
    await api.delete('/analysis/history');
  } catch (error) {
    console.error("Clear History Error:", error);
    throw error;
  }
};

export const deleteHistoryItem = async (id) => {
  try {
    await api.delete(`/analysis/history/${id}`);
  } catch (error) {
    console.error("Delete Item Error:", error);
    throw error;
  }
};
